import React from "react";
import { FooterNovoConhecerLogoProps } from "./FooterNovoConhecerLogo.types";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";
import { FooterNovoConhecerContainerLogo } from "./FooterNovoConhecerLogo.style";

export default class FooterNovoConhecerLogo extends Container<
FooterNovoConhecerLogoProps,
  CoreContainerState
> {
  constructor(props: FooterNovoConhecerLogoProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { backgroundColor } = this.props;

    return (
      <>
        <FooterNovoConhecerContainerLogo $backgroundcolor={backgroundColor}>
          <div className="footer__logo-container">
            {this.childComponents.length > 0 && (
              <div className="footer__logo">
                {this.childComponents[0]}
              </div>
            )}
            {this.childComponents.length > 1 && (
              <div className="footer__logo-grid">
                {this.childComponents.slice(1).map((item, k) => (
                  <div key={k} className="footer__logo">
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="footer__logo-divider"></div>
        </FooterNovoConhecerContainerLogo>
        {this.childComponents.length < 6 && this.placeholderComponent}
      </>
    );
  }
}